import { themeAtom } from "../../shared/atoms";
import type { Tq2ScrubberDetailsProps } from "../models/tech-form-page.models";
import { scrubberTypeOptions } from "../models/tq2-design-details.models";
import { ReactSelectStyling } from "../utils/TechUtils";
import { useAtomValue } from "jotai";
import Select from "react-select";

export function Tq2ScrubberDetails({ form, formErrors, onInputChange, onTypeChange }: Tq2ScrubberDetailsProps) {
  const theme = useAtomValue(themeAtom);
  const selectStyles = ReactSelectStyling();
  return (
    <>
      <div className="mb-4">
        <label className="block text-sm font-medium">Scrubber type</label>
        <Select
          inputId="scrubberType"
          classNamePrefix="rs"
          options={scrubberTypeOptions}
          isSearchable={false}
          placeholder="Select an option"
          value={form.scrubberType}
          onChange={onTypeChange}
          styles={selectStyles}
        />
        {formErrors.scrubberType && <p className="mt-1 text-xs text-red-600">{formErrors.scrubberType}</p>}
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium">Scrubber maker</label>
        <div className="flex items-center">
          <input
            type="text"
            name="scrubberMaker"
            value={form.scrubberMaker}
            onChange={onInputChange}
            className={`mt-1 w-full rounded-md border p-2 focus:outline-none ${
              formErrors.scrubberMaker ? "border-red-600" : theme.uwhcAssistant.border
            }`}
          />
        </div>
        {formErrors.scrubberMaker && <p className="mt-1 text-xs text-red-600">{formErrors.scrubberMaker}</p>}
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium">Is vessel aux. boiler connected to the scrubber?</label>
        <div className="mt-1">
          <label className="inline-flex items-center">
            <input
              type="radio"
              className="form-radio"
              name="isVesselAuxBoilerConnectedToScrubber"
              value="yes"
              checked={form.isVesselAuxBoilerConnectedToScrubber === "yes"}
              onChange={onInputChange}
            />
            <span className="ml-2">Yes</span>
          </label>
          <label className="ml-4 inline-flex items-center">
            <input
              type="radio"
              className="form-radio"
              name="isVesselAuxBoilerConnectedToScrubber"
              value="no"
              checked={form.isVesselAuxBoilerConnectedToScrubber === "no"}
              onChange={onInputChange}
            />
            <span className="ml-2">No</span>
          </label>
        </div>
        {formErrors.isVesselAuxBoilerConnectedToScrubber && (
          <p className="mt-1 text-xs text-red-600">{formErrors.isVesselAuxBoilerConnectedToScrubber}</p>
        )}
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium">
          Is vessel equipped with a NOx Tier III engine and if yes, what fuel grade must be used in Tier III mode?
        </label>
        <div className="flex items-center">
          <input
            type="text"
            name="noxTierIIIEngineFuelGrade"
            value={form.noxTierIIIEngineFuelGrade}
            onChange={onInputChange}
            className={`mt-1 w-full rounded-md border p-2 focus:outline-none ${
              formErrors.noxTierIIIEngineFuelGrade ? "border-red-600" : theme.uwhcAssistant.border
            }`}
          />
        </div>
        {formErrors.noxTierIIIEngineFuelGrade && (
          <p className="mt-1 text-xs text-red-600">{formErrors.noxTierIIIEngineFuelGrade}</p>
        )}
      </div>
    </>
  );
}
